import { render, staticRenderFns } from "./ResetPasswordScreenForm.vue?vue&type=template&id=6458b068&scoped=true&"
import script from "./ResetPasswordScreenForm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordScreenForm.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordScreenForm.vue?vue&type=style&index=0&id=6458b068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458b068",
  null
  
)

export default component.exports